import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { get } from 'lodash';

@Component({
  name: 'bpc-display-field-colorbox',
  components: {},
})
export default class DisplayFieldColorbox extends mixins(AbstractDisplayField) {
  get valueColor(): string {
    const item = this.fieldConfig.valueToColor?.find(item => item.value === this.value);
    return item?.color || this.value;
  }

  get shape(): string {
    return get(this.fieldConfig, 'shape', 'circle');
  }
}
